module.exports = __webpack_public_path__ + "./Sharpay_c556fdfe63751038f5c29b58c033fff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/Sharpay.jpg
// module id = 488
// module chunks = 0